import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import { SettingsContentPanel } from 'app/components/common/SettingsContentPanel';
import { Button, Checkbox, Select } from 'antd';
import { RegulationReasonType } from 'app/model/CORE';
import MeasureUtils from 'app/common/util/MeasureUtils';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

export const REGULATION_OUTLOOK_REASONS = [
    RegulationReasonType.AERODROME_CAPACITY,
    RegulationReasonType.ATC_CAPACITY,
    RegulationReasonType.ATC_INDUSTRIAL_ACTION,
    RegulationReasonType.SPECIAL_EVENT,
    RegulationReasonType.OTHERS,
    RegulationReasonType.WEATHER,
];

export const DEFAULT_REGULATION_OUTLOOK_SETTINGS: RegulationOutlookSettings = {
    minPrediction: 0,
    reasons: REGULATION_OUTLOOK_REASONS,
};

export interface RegulationOutlookSettings {
    minPrediction: number;
    reasons: RegulationReasonType[];
}

export class RegulationOutlookSettingsTitle extends PureComponent {
    render = () => (
        <Flex direction="vertical">
            <div style={{ fontWeight: 'bold' }}>REGULATION OUTLOOK SETTINGS</div>
        </Flex>
    );
}

const MIN_PREDICTION_OPTIONS = [
    { value: 0, label: '0%' },
    { value: 0.3, label: '30%' },
    { value: 0.5, label: '50%' },
    { value: 0.8, label: '80%' },
];

export class RegulationOutlookSettingsContent extends SettingsContentPanel<RegulationOutlookSettings> {
    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '20em', padding: '1em' }}>
                <Flex direction="vertical" style={{ alignSelf: 'center' }}>
                    <Flex style={{ alignItems: 'center', paddingBottom: '1em' }}>
                        <div style={{ width: '8em' }}>Min prediction</div>
                        <Select
                            style={{ width: '6em' }}
                            options={MIN_PREDICTION_OPTIONS}
                            value={this.state.minPrediction}
                            onChange={this.onChange}
                            // Force render  of dropdown inside the popover content
                            // Fix popover hiding on click
                            getPopupContainer={trigger => trigger.parentNode}
                        />
                    </Flex>
                    <Flex>
                        <div style={{ width: '8em' }}>Reasons:</div>
                        <Flex direction="vertical" style={{ gap: '0.5em' }}>
                            {this.renderReasons()}
                        </Flex>
                    </Flex>
                </Flex>
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }

    private renderReasons = () => {
        return REGULATION_OUTLOOK_REASONS.map(reason => {
            return (
                <Checkbox
                    style={{ marginLeft: '8px' }}
                    key={reason}
                    checked={this.state.reasons.includes(reason)}
                    onChange={e => this.onReasonCheck(e, reason)}>
                    {MeasureUtils.toRegulationOutlookReasonString(reason)}
                </Checkbox>
            );
        });
    };

    private onReasonCheck = (event: CheckboxChangeEvent, reason: RegulationReasonType) => {
        if (event.target.checked) {
            this.setState({ reasons: [...this.state.reasons, reason] });
        } else {
            this.setState({ reasons: this.state.reasons.filter(r => r !== reason) });
        }
    };

    private onChange = (minPrediction: number) => this.setState({ minPrediction });
}
